export default __webpack_public_path__ + "static/media/Mascot-Alana@2x.a1fd1644.png";